import { Outlet } from "react-router-dom";
import Footer from "./Footer.tsx";
import { useState, useEffect } from "react";

const Layout = () => {
  const [dimensions, setDimensions] = useState({ width: 390, height: 844 });

  useEffect(() => {
    const updateDimensions = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // Ratio aspect de la mise en page de base
      const baseWidth = 390;
      const baseHeight = 844;
      const aspectRatio = baseWidth / baseHeight;

      let newWidth, newHeight;

      if (windowWidth / windowHeight > aspectRatio) {
        // Si la fenêtre est plus large que le ratio aspect
        newHeight = windowHeight;
        newWidth = newHeight * aspectRatio;
      } else {
        // Si la fenêtre est plus étroite que le ratio aspect
        newWidth = windowWidth;
        newHeight = newWidth / aspectRatio;
      }

      const scaleFactor = newWidth / baseWidth;

      document.documentElement.style.setProperty(
        "--scale-font-size",
        `${20 * scaleFactor}px`
      );

      setDimensions({
        width: newWidth,
        height: newHeight,
      });
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []); // Dépendances vides pour s'assurer que cet effet est exécuté une seule fois

  return (
    <div
      className="siteWrapper"
      style={{
        width: `${dimensions.width}px`,
        height: `${dimensions.height}px`,
        margin: "0 auto", // Centrer horizontalement la mise en page
        position: "relative", // Assurer que le layout soit bien positionné
      }}
    >
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
